import { useEffect, useState } from 'react';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

function detect(): Viewport {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  if (w < 700) return 'mobile';
  if (w < 1100) return 'tablet';
  return 'desktop';
}

export function useViewport(forced?: Viewport): Viewport {
  const [vp, setVp] = useState<Viewport>(() => forced ?? detect());

  useEffect(() => {
    if (forced) {
      setVp(forced);
      return;
    }
    const handler = () => setVp(detect());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [forced]);

  return vp;
}
